module.exports = __webpack_public_path__ + "static/media/London-day.22030667.svg";